import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Chip,
  Breadcrumbs,
  Link
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

/**
 * Component for breadcrumb navigation between campaign views
 */
const BreadcrumbNav = ({ 
  breadcrumbs, 
  isSubid3View, 
  selectedSubid2, 
  handleReturnToMainView 
}) => {
  // Add logging to help debug clicks
  const handleBreadcrumbClick = (breadcrumb) => {
    console.log('Breadcrumb clicked:', { breadcrumb, isSubid3View, selectedSubid2 });
    
    // Always return to main view on All Campaigns click, regardless of value
    if (breadcrumb.value === null || breadcrumb.label === 'All Campaigns') {
      console.log('All Campaigns breadcrumb clicked, explicitly returning to main view...');
      handleReturnToMainView();
      return;
    }
  };

  // Direct handler for back button with debug logging
  const handleBackClick = () => {
    console.log('Back button clicked, returning to main view...');
    // Force return to main view
    handleReturnToMainView();
  };

  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="Campaign navigation breadcrumbs"
      >
        {breadcrumbs.map((crumb, index) => (
          <div key={index}>
            {index === breadcrumbs.length - 1 ? (
              // Last item (current view)
              <Typography 
                variant="body2" 
                color="text.primary"
                fontWeight="bold"
              >
                {crumb.label}
              </Typography>
            ) : (
              // Clickable breadcrumb for navigation
              <Link
                component="button"
                variant="body1"
                color="primary"
                underline="hover"
                onClick={() => handleBreadcrumbClick(crumb)}
                sx={{ cursor: 'pointer' }}
              >
                {crumb.label}
              </Link>
            )}
          </div>
        ))}
      </Breadcrumbs>
      {isSubid3View && (
        <Chip 
          label={`Showing Sub-Campaigns for: ${selectedSubid2}`}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ ml: 2 }}
        />
      )}
      {isSubid3View && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={handleBackClick}
          sx={{ ml: 2 }}
          data-testid="back-to-all-campaigns"
        >
          Back to All Campaigns
        </Button>
      )}
    </Box>
  );
};

export default BreadcrumbNav; 